export enum EAlertLevel {
  WARNING_LOW = 'WARNING_LOW',
  WARNING_HIGH = 'WARNING_HIGH',
  CRITICAL_LOW = 'CRITICAL_LOW',
  CRITICAL_HIGH = 'CRITICAL_HIGH',
}
